
  $(document).ready(function() {
    $('body').on('click', '[name="checkout"], [name="goto_pp"], [name="goto_gc"]', function() {
      if ($('#agree').is(':checked')) {
        $(this).submit();
      }
      else {
        alert("You must agree with the terms and conditions of sales to check out.");
        return false;
      }
    });
  });



//  FAQ Accordion



function validateStep1() {
var isValid = "true";
jQuery(".input-1").each(function() {
   var element = jQuery(this);
   if (element.val() == "") {
     element.addClass('tested');
    alert("Please fill all input fields!");
       isValid = "false";
     return false;
   }
});
  if (isValid == "true") {
  	jQuery('.owl-gen-carousel').trigger('to.owl.carousel', 1);
  }  
}




function validateStep2() {
var isValid = "true";
jQuery(".input-2").each(function() {
   var element = jQuery(this);
   if (element.val() == "") {
     element.addClass('tested');
    alert("Please fill all input fields!");
       isValid = "false";
     return false;
   }
});
  if (isValid == "true") {
  	jQuery('.owl-gen-carousel').trigger('to.owl.carousel', 2);
  }  
}
function validateStep3() {
  jQuery('.owl-gen-carousel').trigger('to.owl.carousel', 3);
}





jQuery(document).ready(function($) {
  
  

    $(".mlvedaform").bind("DOMSubtreeModified", function() {
      if ($("label:contains('mlveda_country')").parent().css('display') !== 'none') {
        $("label:contains('mlveda_country')").parent().css('display', 'none');
      }
    });

  
$('.owl-carousel .owl-dot').hover(function() {
//$(this).click();
  //alert("true");
},
function() {}
);
  
 // Product range tabs

  
  
  // Product selection carousel
  
  $('.owl-stock-compostable-mailers, .owl-custom-mailers, .owl-custom-bubble-mailers, .owl-stock-compostable-bubble-mailer').owlCarousel({
    loop:true,
    margin:0,
    nav:false,
    smartSpeed:0,
    dots: true,
    items:1
})  
  
  
  

  
  var acc = document.getElementsByClassName("accordion");
var i;




for (i = 0; i < acc.length; i++) {
  acc[i].onclick = function() {
        if(jQuery( this ).hasClass( "active" )){
      
      this.classList.remove('active');
        this.style.maxHeight = null;
        this.nextElementSibling.style.maxHeight = null;
      
    }else{
  	for (let i = 0; i < acc.length; i++) {
        acc[i].classList.remove('active');
        acc[i].style.maxHeight = null;
        acc[i].nextElementSibling.style.maxHeight = null;
    }
      
    this.style.maxHeight = this.scrollHeight+'px';
    this.classList.add('active');
          var panel = this.nextElementSibling;
     panel.style.maxHeight = panel.scrollHeight + 'px'
    }
    
  }
}
  
 if ($("#timber-re-leaf-project")[0]){  
   $('.sect-download a').attr("download", true);
   
 }
// Sizing for carousel wrapper
if ($(".wrap-carousel")[0]){  
  var width = window.innerWidth;  
  var innerwidth = jQuery('.wrap-carousel-before').width();
  var contwidth = width - innerwidth;  
  contwidth = contwidth / 2 ;
  var newwidth = innerwidth + contwidth;
  jQuery('.wrap-carousel').width(newwidth);
}

// Carousel for products

  $('.owl-set-carousel-gen').owlCarousel({
    loop:true,
        animateOut: 'fadeOutRight',
    animateIn: 'fadeInLeft',
    margin:20,
    nav:true,
        autoplay:true,
    autoplayTimeout:8000,
    autoplayHoverPause:true,
            responsive:{
            0:{
                items:2
            },
            600:{
                items:3
            },
            1200:{
                items:3
            },
            1700:{
                items:4
            }
        }
})
  
  $('.owl-set-carousel-alt').owlCarousel({
    loop:true,
        animateOut: 'fadeOutRight',
    animateIn: 'fadeInLeft',
    margin:20,
    nav:true,
        autoplay:true,
    autoplayTimeout:8000,
    autoplayHoverPause:true,
            responsive:{
            0:{
                items:1
            },
            600:{
                items:3
            },
            1200:{
                items:3
            },
            1700:{
                items:4
            }
        }
})

$('.block__owl-category-slider--inner').owlCarousel({
    items: 4,
    margin: 10,
    loop: false,
    nav: false,
    // stagePadding adds space on left/right to show part of adjacent slides
    stagePadding: 50, 
    responsive: {
        0: {
            items: 4,
            stagePadding: 30 // Adjust based on how much "peek" you want
        }
    }
});
 
    jQuery('.select-blog li').on('click', function() {
      jQuery('.select-blog li').removeClass('active');
  	jQuery(this).addClass('active');
    var prod_filter = jQuery(this).attr("value");
      jQuery(".grid-article").removeClass('hide-option').removeClass('show-option');
      if(prod_filter != "all"){
      	jQuery('.grid-article').each(function() {
          if (jQuery(this).hasClass(prod_filter)) {
              jQuery(this).addClass('show-option');
          }else{
              jQuery(this).addClass('hide-option');
          }
        });
      }
    
    });
  
  
// Nav product hover
  
    jQuery(".prod-link").hover(function(){
           
    var prod_img = jQuery(this).attr("value");
      var prod_pre = "#prod-img-";
      var prod_img_full = prod_pre.concat(prod_img);
       jQuery('.prod-img').removeClass("active");
      jQuery(prod_img_full).addClass("active");

  });
  
  
  
  
//resetBrushbox();
  
  
  jQuery('.inner-int').on('click', function() {
  	jQuery('.inner-int').removeClass('active');
    jQuery(this).addClass('active');
    document.getElementById('ContactFormInterest').value = jQuery(this).attr('value');
  
  })
  
  // Scroll top
  jQuery("a[href='#top']").click(function() {
  jQuery("html, body").animate({ scrollTop: 0 }, "slow");
  return false;
});
  
  
  
$('.drawer--right').on('classChanged', function(){ 

alert("yes");
});  
  
  
  var owl = jQuery('.owl-gen-carousel');
  owl.owlCarousel();
  
  // Go to the next item
  $('.button-forward').click(function() {
      //owl.trigger('next.owl.carousel');
  })
  
  $('.button-back').click(function() {
    // With optional speed parameter
    // Parameters has to be in square bracket '[]'
    owl.trigger('prev.owl.carousel');
})
  
  
 
   jQuery('.select-start').on('click', function() {
     jQuery('.select-intro').fadeOut();
      jQuery('.select-steps').delay(1000).fadeIn();
  });
  
     jQuery('.button-reverse').on('click', function() {
     jQuery('.select-steps').fadeOut();
      jQuery('.select-intro').delay(1000).fadeIn();
  });
  

  
  
  
// COUNTER - Start
  
 
  
 // COUNTER - END
  
});
if(jQuery("#counter").length != 0) {
var a = 0;
$(window).scroll(function() {

  var oTop = $('#counter').offset().top - window.innerHeight;
  if (a == 0 && $(window).scrollTop() > oTop) {
    $('.counter-value').each(function() {
      var $this = $(this),
        countTo = $this.attr('data-count');
      $({
        countNum: $this.text()
      }).animate({
          countNum: countTo
        },

        {

          duration: 2000,
          easing: 'swing',
          step: function() {
            $this.text(Math.floor(this.countNum));
          },
          complete: function() {
            $this.text(this.countNum);
            //alert('finished');
          }

        });
    });
    a = 1;
  }

});
}